<template>
  <div
    class="scrollButton"
    @click="action()"
    v-bind:style="`transform: rotate(${degs}deg)`"
  ></div>
</template>

<script>
export default {
  name: "ScrollButton",
  props: {
    degs: Number,
    action: Function,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scrollButton {
  transition: transform ease-in-out 0.5s;

  background-image: url("/arrow.svg");
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;

  height: 2rem;
  width: 2rem;
}
</style>
